import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Col,
  Row,
  InputNumber,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { binService, companyService, rackService } from "_services";

function Add({ history }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [addressLoading, setAddressLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [racks, setRacks] = useState([]);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    getCompaniesAndAddresses();
    getRacks();
  }, []);

  const getCompaniesAndAddresses = () => {
    setIsDataLoading(true);
    companyService
      .getSuggestion("")
      .then((x) => {
        if (x.content) {
          setIsDataLoading(false);
          const storeItems = x.content.filter((item) =>
            item.companyCategories.some((category) => category.code === "STO")
          );
          const customerItems = x.content.filter((item) =>
            item.companyCategories.some((category) => category.code === "CUS")
          );
          const supplierItems = x.content.filter((item) =>
            item.companyCategories.some((category) => category.code === "SUP")
          );
          setCompanies(storeItems);
          setCustomers(customerItems);
          if (storeItems && storeItems.length === 1) {
            setIsDataLoading(true);
            companyService
              .getById(storeItems[0].id)
              .then((data) => {
                setIsDataLoading(false);
                const warehouseLocations = data.content.addresses.filter(
                  (item) => item.addressType === "WAREHOUSE"
                );
                setAddresses(warehouseLocations);
                if (warehouseLocations.length === 1) {
                  form.setFieldsValue({
                    tenant: customerItems[0],
                    store: storeItems[0],
                    storeLocation: warehouseLocations[0],
                  });
                }
              })
              .catch((error) => {
                setIsDataLoading(false);
              });
          }
        }
        setIsDataLoading(false);
      })
      .catch((error) => {
        setIsDataLoading(false);
      });
  };

  const getRacks = () => {
    rackService
      .search("")
      .then((x) => {
        setRacks(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSumbit = (e) => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        //values.numberOfBin = 501;
        //values.storeLocation = { id: values.storeLocation.id, name: "BNS-2" };
        // console.log("PL:", values);
        binService
          .create(values)
          .then(() => {
            message.success("Successfully created!");
            setIsLoading(false);
            history.push(".");
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Button
        type="primary"
        key="save"
        htmlType="submit"
        loading={isLoading}
        onClick={(e) => handleFormSumbit(e)}
      >
        Save
      </Button>
    );
    buttons.push(
      <Button key="cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  const onCancel = () => {
    history.push(".");
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/bins">Bin Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/bins/add">New Bin</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Spin tip="Initial data loading..." spinning={isDataLoading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item
                    name="code"
                    label="Code"
                    rules={[{ required: true, message: "Code is required" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name={["store", "id"]}
                    label="Store"
                    rules={[{ required: true, message: "Store is required" }]}
                  >
                    <Select
                      placeholder="Please select"
                      //onChange={getCompanyAddresses}
                      allowClear
                    >
                      {companies.length > 0 &&
                        companies.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name={["rack", "id"]}
                    label="Rack"
                    rules={[{ required: false, message: "Rack is required" }]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {racks.length > 0 &&
                        racks.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item name="name" label="Name">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name={["tenant", "id"]}
                    label="Customer"
                    rules={[
                      { required: true, message: "Customer is required" },
                    ]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {customers.length > 0 &&
                        customers.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}></Col>
              </Row>
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item name="note" label="Remarks">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name={["storeLocation", "id"]}
                    label="Location"
                    rules={[
                      { required: true, message: "Store location is required" },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      loading={addressLoading}
                      allowClear
                    >
                      {addresses.length > 0 &&
                        addresses.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.address}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}></Col>
              </Row>
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
